import React from 'react';
import { contextFactory } from '../factories/contextFactory.js';

const [LanguageContext, useLanguage] = contextFactory('LanguageContext', 'ru');
const Language = ({ children, language }) => {
    return React.createElement(LanguageContext, { value: language }, children);
};

export { Language, useLanguage };
//# sourceMappingURL=Language.js.map
